import { useCallback } from 'react';
import { useMarketCouponRedeemAll } from '../queries/useMarketCouponRedeemAll';
import { useMyInfo } from 'shared/src/queries';
import { bridge } from 'shared/src/utils';
import { useSafeTimeout } from 'shared/src/hooks';
import { useLogCompleteDownloadCoupon } from './useLogCompleteDownloadCoupon';

export const useOnPressMarketCouponRedeemAll = (marketId: number) => {
  const { mutateAsync: redeemAllCoupon, isPending: loadingRedeemAllCoupon } =
    useMarketCouponRedeemAll(marketId);
  const { data: myInfo } = useMyInfo();
  const logCompleteRedeemCoupon = useLogCompleteDownloadCoupon();
  const setSafeTimeout = useSafeTimeout();

  return {
    loading: loadingRedeemAllCoupon,
    action: useCallback(async () => {
      if (!myInfo) return;
      if (myInfo.is_anonymous) {
        bridge.assertLogin({ redirect: `/markets/${marketId}` });
        setSafeTimeout(() => {
          bridge.toast('로그인이나 회원가입이 필요해요');
        }, 200);
        return;
      }
      redeemAllCoupon()
        .then(() => {
          logCompleteRedeemCoupon({ isDownloadAll: true });
        })
        .catch(() => {
          /* onError에서 toast로 처리됨 */
        });
    }, [
      marketId,
      myInfo,
      redeemAllCoupon,
      logCompleteRedeemCoupon,
      setSafeTimeout,
    ]),
  };
};
